import { render, staticRenderFns } from "./associated_customer.vue?vue&type=template&id=0c2fec9a&scoped=true"
import script from "./associated_customer.vue?vue&type=script&lang=js"
export * from "./associated_customer.vue?vue&type=script&lang=js"
import style0 from "./associated_customer.vue?vue&type=style&index=0&id=0c2fec9a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fec9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2fec9a')) {
      api.createRecord('0c2fec9a', component.options)
    } else {
      api.reload('0c2fec9a', component.options)
    }
    module.hot.accept("./associated_customer.vue?vue&type=template&id=0c2fec9a&scoped=true", function () {
      api.rerender('0c2fec9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_client_management/form/associated_customer/associated_customer.vue"
export default component.exports